"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVG = void 0;
const react_1 = __importDefault(require("react"));
const WellthLogo_1 = __importDefault(require("./WellthLogo"));
const Scale_1 = __importDefault(require("./Scale"));
const BloodPressure_1 = __importDefault(require("./BloodPressure"));
const Glucose_1 = __importDefault(require("./Glucose"));
const Meal_1 = __importDefault(require("./Meal"));
const Medication_1 = __importDefault(require("./Medication"));
const Sleep_1 = __importDefault(require("./Sleep"));
const Flag_1 = __importDefault(require("./Flag"));
const Appointment_1 = __importDefault(require("./Appointment"));
const Hydration_1 = __importDefault(require("./Hydration"));
const SVG = _ref => {
  let name = _ref.name,
    width = _ref.width,
    height = _ref.height;
  switch (name.toUpperCase()) {
    case "BLOODPRESSURE":
      return react_1.default.createElement(BloodPressure_1.default, {
        width: width,
        height: height
      });
    case "GLUCOSE":
      return react_1.default.createElement(Glucose_1.default, {
        width: width,
        height: height
      });
    case "MEAL":
      return react_1.default.createElement(Meal_1.default, {
        width: width,
        height: height
      });
    case "MEDICATION":
      return react_1.default.createElement(Medication_1.default, {
        width: width,
        height: height
      });
    case "WELLTHLOGO":
      return react_1.default.createElement(WellthLogo_1.default, null);
    case "SCALE":
      return react_1.default.createElement(Scale_1.default, {
        width: width,
        height: height
      });
    case "SLEEP":
      return react_1.default.createElement(Sleep_1.default, {
        width: width,
        height: height
      });
    case "DEMO":
      return react_1.default.createElement(Flag_1.default, {
        width: width,
        height: height
      });
    case "APPOINTMENT":
      return react_1.default.createElement(Appointment_1.default, {
        width: width,
        height: height
      });
    case "HYDRATION":
      return react_1.default.createElement(Hydration_1.default, {
        width: width,
        height: height
      });
    default:
      return null;
  }
};
exports.SVG = SVG;
exports.default = exports.SVG;